import React from "react";
import Modal from "react-bootstrap/Modal";
import { displayPractitionerName, practitionerIdFromUser } from "../names";
import DashboardAppointmentsCard from "./DashboardAppointmentsCard";

const ViewProviderAppointments = ({ modalShow, handleShow, organizationRef }) => {
  const practitionerRef = practitionerIdFromUser(modalShow);
  if (!modalShow) return null;
  return (
    <Modal show onHide={handleShow} size="xl" centered className="custom-dialog">
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Viewing Appointments for {displayPractitionerName(modalShow)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {practitionerRef ? (
          <DashboardAppointmentsCard
            key={`${organizationRef}:${practitionerRef}`}
            listOnly
            organizationRef={organizationRef}
            practitionerRef={practitionerRef}
          />
        ) : (
          <p>This user has no practitioner record.</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewProviderAppointments;
